import {Component, Input, OnInit} from '@angular/core';
import {OfferCoveragesGroupComparisonData} from '../offers-comparison-dialog.component';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {OfferCoveragesService} from '../../../../../core/services/impl/offer-coverages.service';

@Component({
  selector: 'app-offers-comparison-coverages-group',
  templateUrl: './offers-comparison-coverages-group.component.html'
})
export class OffersComparisonCoveragesGroupComponent implements OnInit {

  @Input() coveragesGroup: OfferCoveragesGroupComparisonData;
  @Input() offers: Offer[];

  constructor(public offerCoveragesService: OfferCoveragesService) { }

  ngOnInit() {
  }

}
